/**
 * Where things are. Every page about a container's contents lives under its container,
 * so a link always says which one it means; these build those paths so no call site
 * spells one by hand.
 */
export type ContainerSection = 'overview' | 'keys' | 'api-tokens' | 'firewalls' | 'usage';

const SECTIONS: readonly ContainerSection[] = ['overview', 'keys', 'api-tokens', 'firewalls', 'usage'];

export const containerPath = (containerId: string, section: ContainerSection = 'overview') =>
  `/containers/${containerId}/${section}`;

export const keyPath = (containerId: string, keyId: string, tab?: 'versions' | 'activity') =>
  `/containers/${containerId}/keys/${keyId}${tab ? `/${tab}` : ''}`;

/**
 * The section a path is in: a container page's own, or one of the flat paths that
 * redirect into the current container. `null` for a tenant page. A key's page is in
 * `keys`, which is where switching container from one lands: the key itself stays in its
 * own container.
 */
export function sectionOf(pathname: string): ContainerSection | null {
  const parts = pathname.split('/').filter(Boolean);
  const candidate = parts[0] === 'containers' ? parts[2] : parts[0];
  return SECTIONS.find((section) => section === candidate) ?? null;
}
